import { useGetMeQuery } from "@/store/userAPI"

export type EntityType = "company" | "municipality"

/** Which sidebar the user sees. An admin marks the organisation as a
 * municipality in Admin -> Companies; everyone else is a company (MPE-988). */
export const useEntityType = (): EntityType => {
  const { data } = useGetMeQuery()
  return data?.session?.organizationSetup?.organization?.type === "MUNICIPALITY" ? "municipality" : "company"
}
